"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const CommonWeb_1 = require("./CommonWeb");
const TGLabelWrapperWeb_1 = __importDefault(require("./TGLabelWrapperWeb"));
const useDataProvider_1 = require("../../hooks/useDataProvider");
const TGOptionSelectorModalWeb_1 = __importDefault(require("../Common/Modals/TGOptionSelectorModalWeb"));
const clsx_1 = __importDefault(require("clsx"));
const hooks_1 = require("../../hooks");
const TGSelectFieldWeb = props => {
    const { options, label, value: unknownValue, dataProvider, placeholder, onChange, multiSelect, readOnly, required, error, helperText, warning, info, } = props;
    const classes = CommonWeb_1.useStyles({ error });
    const { searchText, handleSearchText } = hooks_1.useSearch();
    const [selectedOptions, setSelectedOptions] = react_1.useState([]);
    const value = react_1.useMemo(() => {
        if (Array.isArray(unknownValue)) {
            return unknownValue.map(x => {
                if (typeof x === 'number' || typeof x === 'string')
                    return x;
                return String(x);
            });
        }
        else if (typeof unknownValue === 'number' || typeof unknownValue === 'string')
            return unknownValue;
        return String(unknownValue);
    }, [unknownValue]);
    const [optionSelectorOpen, setOptionSelectorOpen] = react_1.useState(false);
    const { options: dataProviderOptions, computeOptions, valueOptions, clearPageInfo, pageInfo, loading, } = useDataProvider_1.useDataProvider({
        dataProvider,
        options,
        value,
        searchText,
        selectedOptions,
    });
    react_1.useEffect(() => {
        clearPageInfo();
        computeOptions(undefined, true); //Load options right away so initial values will show up correctly
    }, []);
    react_1.useEffect(() => {
        if (optionSelectorOpen) {
            clearPageInfo();
            computeOptions(undefined, true);
        }
    }, [searchText]);
    const [tooltip, setTooltip] = react_1.useState(false);
    const openOptionSelectorModal = () => {
        if (readOnly) {
            return;
        }
        setOptionSelectorOpen(true);
    };
    const closeOptionSelectorModal = () => {
        setOptionSelectorOpen(false);
    };
    const Selectedvalue = valueOptions === null || valueOptions === void 0 ? void 0 : valueOptions.map(valueOption => valueOption.label).join(', ');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: classes.selectRoot },
                react_1.default.createElement("div", { className: classes.selectBody },
                    react_1.default.createElement(TGLabelWrapperWeb_1.default, { required: required, readOnly: readOnly, label: label, info: info, tooltip: tooltip, error: error }),
                    react_1.default.createElement(core_1.TextField, { className: clsx_1.default(warning && classes.warningBorderBottom), onClick: openOptionSelectorModal, value: Selectedvalue || '', placeholder: placeholder, error: error, variant: "outlined", className: clsx_1.default(classes.formElementWrapper, classes.customBorderColor, classes.selectInput), InputProps: {
                            readOnly: true,
                            disabled: readOnly,
                        }, multiline: true, minRows: 1, onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false), fullWidth: true, InputLabelProps: {
                            shrink: true,
                            className: clsx_1.default(classes.labelShrink, warning && classes.warningText),
                        } }),
                    !!helperText && react_1.default.createElement(core_1.FormHelperText, { className: clsx_1.default(warning && classes.warningText, classes.errorText) }, helperText)),
                react_1.default.createElement("div", { onClick: openOptionSelectorModal, className: classes.endAdormentIcon },
                    react_1.default.createElement(SelectIcon, null)))),
        react_1.default.createElement(TGOptionSelectorModalWeb_1.default, { open: optionSelectorOpen, filterPlaceHolder: "Search", pathToLabel: "label", pathToValue: "value", multiSelect: multiSelect, onDone: (value) => {
                onChange(value);
                closeOptionSelectorModal();
            }, onCancel: closeOptionSelectorModal, options: dataProviderOptions || [], title: label || 'Select a Option', value: value, setOpen: setOptionSelectorOpen, fetchMoreData: computeOptions, hasNextPage: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) || false, clearPageInfo: clearPageInfo, searchText: searchText, handleSearchText: handleSearchText, setSelectedOptions: setSelectedOptions, loading: loading })));
};
const SelectIcon = () => {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "13", viewBox: "0 0 8 13", fill: "none" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1.5L1.5 0L8 6.5L1.5 13L0 11.5L5 6.5L0 1.5Z", fill: "#AAAAAA" })));
};
exports.default = TGSelectFieldWeb;
//# sourceMappingURL=TGSelectFieldWeb.js.map